import React from 'react'
import css from './pageContent.module.scss'

const PageContent: React.FC<React.PropsWithChildren<unknown>> = (props) => {
  return <div className={css.page_content} {...props} />
}

export default PageContent
